// extracted by mini-css-extract-plugin
export default {"shopNow":"shopNow_shopNow__9iKoG","shopNowContainer":"shopNow_shopNowContainer__h2bXF","shopNowImg":"shopNow_shopNowImg__fkx+G","shopNowBtn":"shopNow_shopNowBtn__9BrMK"};